import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import { MenuItem } from 'primeng/api'

export interface UserProfile {
  firstName: string
  lastName: string
  userProfileImage?: string
  [key: string]: any
}

/**
 * @deprecated This component has been deprecated. Functionality has been moved to the Navmenu.
 */
@Component({
  selector: 'basin-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss'],
})
export class ActionBarComponent implements OnInit, OnChanges {
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth <= 600) {
      this.mobile = true
    } else {
      this.mobile = false
    }
  }
  @Input() displayTitle: boolean = false
  @Input() applicationTitle: string = ''
  @Input() logo: string = ''
  @Input() grayBackground: boolean = false
  @Input() menuThemeColor: string = ''
  @Input() homeSelected: boolean = false
  @Output() homeIconClicked: EventEmitter<any> = new EventEmitter()
  @Input() searchIcon: boolean = false
  searchIsActive: boolean = false
  searchString: string = null
  @Input() dropdownMenuSelector: boolean = false
  @Input() dropdownMenuItems: MenuItem[] = []
  mappedDropdownMenuItems: MenuItem[]
  dropdownMenuIsOpen: boolean = false
  @Input() selectedDropdownMenuItem: MenuItem
  @Input() activeUsers: boolean = false
  @Input() userProfiles: UserProfile[] = []
  @Input() notificationsBell: boolean = false
  @Input() notifications: string[] = []
  @Input() customNotifications: boolean = false
  notificationsIsOpen: boolean = false
  @Input() badgeValue: string
  @Input() ellipsesMenu: boolean = false
  @Input() ellipsesMenuItems: MenuItem[] = []
  ellipsesMenuIsOpen: boolean = false
  @Input() showProfile: boolean = false
  @Input() profileImage: string = ''
  @Input() profileMenuItems: MenuItem[] = []
  profileMenuIsOpen: boolean = false
  @Input() mobile: boolean
  spaceCount: number
  @Output() searchStringChange: EventEmitter<string> =
    new EventEmitter<string>()
  @Output() searchEntered: EventEmitter<string> = new EventEmitter<string>()

  ngOnInit(): void {
    this.onResize()
    this.setDefaultBadgeValue()
    this.dropdownMenuSelector && this.mapDropdownMenuItems()
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setDefaultBadgeValue()
    this.countForSpacing()
    this.dropdownMenuSelector && this.mapDropdownMenuItems()
  }

  mapDropdownMenuItems() {
    this.mappedDropdownMenuItems = this.dropdownMenuItems.map(
      (item: MenuItem) => {
        return {
          ...item,
          command: (event) => {
            this.selectedDropdownMenuItem = item
            if (item.command) {
              item.command(event)
            }
          },
        }
      }
    )
    if (!this.selectedDropdownMenuItem) {
      this.selectedDropdownMenuItem = this.mappedDropdownMenuItems?.[0]
    }
  }

  countForSpacing() {
    this.spaceCount = 0
    let toCount = [
      'searchIcon',
      'notificationsBell',
      'ellipsesMenu',
      'showProfile',
    ]
    toCount.forEach((item) => {
      if (this[item] === true) {
        this.spaceCount++
      }
    })
  }

  setDefaultBadgeValue() {
    if (
      this.badgeValue == undefined &&
      this.notifications != undefined &&
      this.notifications.length > 0
    ) {
      this.badgeValue = String(this.notifications.length)
    }
  }

  homeClicked() {
    this.homeIconClicked.emit()
  }

  searchStringChanged(searchString) {
    this.searchString = searchString
    this.searchStringChange.emit(searchString)
  }

  searchEnter(searchString) {
    this.searchEntered.emit(searchString)
    this.searchClicked()
  }

  searchClicked() {
    this.searchIsActive = !this.searchIsActive
  }
}
